<template>
<div class="container" style="overflow: hidden;">
  <form v-on:submit.prevent>
    <div class="row">
      <p class="intro" v-html="getIntroText()"></p>
    </div>
    <div class="form-row">
      <div class="form-group col-md-6">
        <input type="text" class="form-control" :placeholder="getFirstNamePlaceholder()" :aria-label="getFirstNamePlaceholder()" name="firstName" id="firstName" v-model="firstName">
      </div>
      <div class="form-group col-md-6">
        <input type="text" class="form-control" :placeholder="getLastNamePlaceholder()" :aria-label="getLastNamePlaceholder()" name="lastName" id="lastName" v-model="lastName">
      </div>
    </div>
    <div class="form-group">
      <input type="text" class="form-control" :placeholder="getEmailPlaceholder()" :aria-label="getEmailPlaceholder()" name="email" id="email" v-model="email">
    </div>
    <button type="submit" class="submitButton btn btn-primary" v-bind:disabled="disabled || submitButtonDisabled" v-on:click="onOpenChat">{{ getStartButtonLabel() }}</button>
  </form>
</div>
</template>

<script>
export default {
  data () {
    return {
      firstName: null,
      lastName: null,
      email: null,
      disabled: true,
      emailIsValid: false
    }
  },

  methods: {
    checkInput: function () {
      this.emailIsValid = this.validEmail(this.email)
      if (this.firstName && this.lastName && this.email && this.emailIsValid) {
        this.disabled = false
      } else {
        this.disabled = true
      }
    },

    onOpenChat (event) {
      this.$emit('submitted', true, false, this.firstName, this.lastName, this.email)
    },

    validEmail (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },

    getIntroText() {
      return this.introText
    },

    getFirstNamePlaceholder() {
      return this.useEnglishAndFrenchTexts ? 'Prénom / First Name' : 'First Name'
    },
    getLastNamePlaceholder() {
      return this.useEnglishAndFrenchTexts ? 'Nom de famille / Last Name' : 'Last Name'
    },
    getEmailPlaceholder() {
      return this.useEnglishAndFrenchTexts ? 'Adresse de courriel / Email Address' : 'Email Address'
    },
    getStartButtonLabel() {
      return this.useEnglishAndFrenchTexts ? 'Commencer / Start' : 'Start'
    }
  },

  props: ['intro-text', 'submit-button-disabled', 'use-english-and-french-texts'],

  watch: {
    'firstName': function (newValue, oldValue) {
      this.firstName = newValue
      this.checkInput()
    },

    'lastName': function (newValue, oldValue) {
      this.lastName = newValue
      this.checkInput()
    },

    'email': function (newValue, oldValue) {
      this.email = newValue
      this.checkInput()
    }
  }
}
</script>

<style>
.removePadding {
  padding-right: 0px !important;
  padding-left: 0px !important;
}

.form {
  padding: 3vh;
  padding-left: 0;
  padding-right: 0;
  text-align: left;
  font-size: 14px;
}

.intro {
  text-align: left;
  margin-top: 20px;
  word-wrap: break-word;
  margin-left: 15px;
  margin-right: 20px;
  font-size: 14px;
  color: #2d2d2d;
}

input {
  font-size: 16px !important;
  color: #2d2d2d !important;
}

input:hover {
  -webkit-box-shadow: 0px 0px 3px 1px rgba(215,213,213,1);
  -moz-box-shadow: 0px 0px 3px 1px rgba(215,213,213,1);
  box-shadow: 0px 0px 3px 1px rgba(215,213,213,1);
}

.form-control:focus {
  border-color: #d7d5d5;
  -webkit-box-shadow: 0px 0px 3px 1px rgba(215,213,213,1);
  -moz-box-shadow: 0px 0px 3px 1px rgba(215,213,213,1);
  box-shadow: 0px 0px 3px 1px rgba(215,213,213,1);
}

.submitButton {
  margin-top: 10px;
  background-color: #0073bc;
  border: none;
  font-size: 14px;
}

.submitButton:enabled:hover {
  background-color: #3984b7 !important;
}

.submitButton:disabled {
  background-color: #e7e6e6;
  color: #404040;
  border: none;
}

</style>



// WEBPACK FOOTER //
// src/components/IntroForm.vue